import ActualizationOk from './ActualizationOk.css';
export default {
    ActualizationOk
};
